import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaymentFrequencyPage } from './payment-frequency.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentFrequencyPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentFrequencyPageRoutingModule {}
